module.exports = __webpack_public_path__ + "img/424-a25549.png";